import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BlogService } from '../service/blog.service';
import * as blogActions from '../action/blog.action';
import { catchError, exhaustMap } from 'rxjs/operators';
import { map, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';



@Injectable()
export class BlogEffect {
  blog$ = createEffect(() => this.actions$.pipe(
    ofType(blogActions.blog),
    exhaustMap(() => this.blogService.blog().pipe(
      map(blog => blogActions.blogSuccess({ blog })),
      catchError((httpErrorResponse: HttpErrorResponse) => {
        return of(blogActions.blogFailure(({ error: httpErrorResponse.error })));
      })
    )))
  )

  blogLoadMore$ = createEffect(() => this.actions$.pipe(
    ofType(blogActions.blogLoadMore),
    exhaustMap((props) => this.blogService.blogLoadMore(props.start).pipe(
      map(articles => blogActions.blogLoadMoreSuccess({ blog: articles })),
      catchError((httpErrorResponse: HttpErrorResponse) => {
        return of(blogActions.blogLoadMoreFailure(({ error: httpErrorResponse.error })));
      })
    )))
  )

  constructor(
    private actions$: Actions,
    private blogService: BlogService
  ) { }
}
